import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartBarIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.25 10.9375H11.8125V2.1875C11.8125 2.07147 11.7664 1.96019 11.6844 1.87814C11.6023 1.79609 11.491 1.75 11.375 1.75H8.3125C8.19647 1.75 8.08519 1.79609 8.00314 1.87814C7.92109 1.96019 7.875 2.07147 7.875 2.1875V4.375H5.25C5.13397 4.375 5.02269 4.42109 4.94064 4.50314C4.85859 4.58519 4.8125 4.69647 4.8125 4.8125V7H2.625C2.50897 7 2.39769 7.04609 2.31564 7.12814C2.23359 7.21019 2.1875 7.32147 2.1875 7.4375V10.9375H1.75C1.63397 10.9375 1.52269 10.9836 1.44064 11.0656C1.35859 11.1477 1.3125 11.259 1.3125 11.375C1.3125 11.491 1.35859 11.6023 1.44064 11.6844C1.52269 11.7664 1.63397 11.8125 1.75 11.8125H12.25C12.366 11.8125 12.4773 11.7664 12.5594 11.6844C12.6414 11.6023 12.6875 11.491 12.6875 11.375C12.6875 11.259 12.6414 11.1477 12.5594 11.0656C12.4773 10.9836 12.366 10.9375 12.25 10.9375ZM8.75 2.625H10.9375V10.9375H8.75V2.625ZM5.6875 5.25H7.875V10.9375H5.6875V5.25ZM3.0625 7.875H4.8125V10.9375H3.0625V7.875Z",
		fill: "currentColor"
	})
});
export default SvgChartBarIcon;
